module.exports = __webpack_public_path__ + "assets/img/feature_04.4024ea2e.png";